export default __webpack_public_path__ + "static/varnish-4b1dcbb9aadd9b156a04fc7833904d9a.png";